import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Calendar, BookOpen, Target, Settings, ListOrdered, UserCircle, BarChart3 } from 'lucide-react';
import { useTeamStore } from '../../store/teamStore';
import Logo from './Logo';

export const Sidebar: React.FC = () => {
  const location = useLocation();
  const { currentTeam } = useTeamStore();

  const navigation = [
    { name: 'Home', href: '/', icon: Home },
    { name: 'Roster', href: '/players', icon: Users },
    { name: 'Depth Chart', href: '/depth-chart', icon: ListOrdered },
    { name: 'Practices', href: '/practices', icon: Calendar },
    // { name: 'Playbook', href: '/playbook', icon: BookOpen },
    // Only show Game Plans for football teams
    ...(currentTeam?.sport === 'Football' ? [{ name: 'Game Plans', href: '/game-plans', icon: Target }] : []),
    // Only show Games for baseball/softball teams
    ...(currentTeam?.sport === 'Baseball' || currentTeam?.sport === 'Softball' 
      ? [{ name: 'Games', href: '/games', icon: BarChart3 }] 
      : []),
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  return (
    <div className="flex flex-col w-64 bg-dark text-white min-h-screen p-4">
      <div className="mb-8">
        <Link to="/" className="flex items-center">
          <Logo className="h-10" />
        </Link>
      </div>

      {currentTeam && (
        <div className="mb-6 px-4 py-3 bg-primary bg-opacity-10 rounded-lg">
          <h3 className="font-medium text-sm text-primary">Current Team</h3>
          <p className="text-white font-semibold">{currentTeam.name}</p>
        </div>
      )}

      <nav className="flex-1">
        <ul className="space-y-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-primary bg-opacity-20 text-white'
                      : 'text-stone hover:bg-primary hover:bg-opacity-10'
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  <span>{item.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="mt-auto pt-4 border-t border-stone border-opacity-20">
        <div className="px-4 py-2">
          <p className="text-sm text-stone">© 2025 Hustli</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 